<template>
  <div class="filter-field">
    <label v-if="fieldLabel" :for="inputId" class="filter-field-label">{{ fieldLabel }}</label>
    <Multiselect :id="inputId" v-bind="$attrs" class="filter-multiselect">
      <template v-for="(_, slot) in $slots" #[slot]="scope">
        <slot :name="slot" v-bind="scope || {}" />
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

let filterMultiselectId = 0

export default {
  name: 'FilterMultiselect',
  components: { Multiselect },
  inheritAttrs: false,
  props: {
    fieldLabel: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
  },
  computed: {
    inputId() {
      return this.id || `filter-multiselect-${this._uid || ++filterMultiselectId}`
    },
  },
}
</script>
